<template>
    <button type="button" @click.prevent="btt" :style="{ opacity: showBtn / 1, right: (50 - (!showBtn * 100)) + 'px' }">
        <svg fill="#3dc9b1" height="40px" width="40px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-33 -33 396.00 396.00" xml:space="preserve" stroke="#3dc9b1" stroke-width="8.91" transform="rotate(0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.66"></g><g id="SVGRepo_iconCarrier"> <g id="XMLID_109_"> <path id="XMLID_110_" d="M25.607,190.607L164.997,51.214l139.396,139.393C307.323,193.536,311.161,195,315,195 c3.839,0,7.678-1.464,10.606-4.394c5.858-5.858,5.858-15.355,0-21.213l-150.003-150C172.79,16.58,168.976,15,164.997,15 s-7.794,1.581-10.607,4.394l-149.997,150c-5.858,5.858-5.858,15.355,0,21.213C10.251,196.465,19.749,196.465,25.607,190.607z"></path> <path id="XMLID_138_" d="M175.603,139.393c-2.813-2.813-6.628-4.393-10.606-4.393c-3.979,0-7.794,1.581-10.607,4.394l-149.996,150 c-5.858,5.858-5.858,15.355,0,21.213c5.857,5.857,15.355,5.858,21.213-0.001l139.39-139.393l139.397,139.394 C307.323,313.536,311.161,315,315,315c3.839,0,7.678-1.464,10.606-4.394c5.858-5.858,5.858-15.355,0-21.213L175.603,139.393z"></path> </g> </g></svg>
    </button>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

function btt() {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
    })
}

const dynY = ref(0)
const height = ref(0)

function setY() {
    dynY.value = window.scrollY
    height.value = document.body.scrollHeight - document.documentElement.clientHeight
}
addEventListener('scroll', setY)
setY()

watch(dynY, () => {
    showBtn.value = (height.value > 1.6 * document.documentElement.clientHeight) && (dynY.value > document.documentElement.clientHeight)
})

const showBtn = ref(false)

</script>

<style scoped>

    button {
        position: fixed;
        background-color: transparent;
        border: none;
        color: #3dc9b1;
        text-shadow: 0 0 10px #0005;
        bottom: 50px;
        right: 50px;
        display: block;
        z-index: 99999;
        font-size: 20px;
        animation: smoothGlow 2s ease-in 5s infinite;
        transition: opacity .4s ease-in, right .3s ease-in;
        opacity: 1;
    }

    @keyframes smoothGlow {
        0%,13%, 100% {
            bottom: 50px;
        }
        5% {
            bottom: 55px;
        }
    }

</style>